import gql from 'graphql-tag'

export const NOTIFICATION_GENERAL_LIST = gql`
 query RawAlerts($filter: GetRawAlertFilter) {
  rawAlerts(filter: $filter) {
    isSuccessful
    message
    rawAlerts {
      data {
        address
        createdOn
        address
        vehicleId
        vehicle {
          licensePlate
          id
          vehicleType {
            type
            model
            category
          }
          device {
            imei
            phoneNo
          }
          imei
        }
        alertCode
        alert {
          alertCode
          descriptionEng
          descriptionIdn
        }
        driverId
        driver {
          fullname
          userId
        }
        alertFlag
        alertData
        latitude
        longitude
        alertTrigger
        threshold
      }
      pagination {
        total
        page
        show
        startCursor
        endCursor
      }
    }
  }
}
`

export const NOTIFICATION_LIST_CODES = gql`
query AlertCodes {
  alertCodes {
    isSuccessful
    message
    alertCodes {
      alertCode
      descriptionEng
      descriptionIdn
    }
  }
}
`

export const CREATE_NOTIFICATION = gql`
mutation CreateNotification($input: CreateNotificationInput!) {
  createNotification(input: $input) {
    isSuccessful
    message
    notification {
      vehicleId
      vgroupId
      ugroupId
      userId
      alertCode
      byEmail
      byPush
    }
  }
}
`

export const GET_NOTIFICATIONS = gql`
query Notifications($filter: GetNotificationInput) {
  notifications(filter: $filter) {
    isSuccessful
    message
    notifications {
      vehicleId
      vgroupId
      ugroupId
      userId
      alertCode
      byEmail
      byPush
    }
  }
}
`